var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobApplicationIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 328.427,
    height: 239.925,
    viewBox: "0 0 328.427 239.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "job_application_icon2",
    transform: "translate(-1685.748 -5133.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172486",
    "data-name": "\\uADF8\\uB8F9 172486",
    transform: "translate(1724 5107.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165643",
    "data-name": "\\uADF8\\uB8F9 165643",
    transform: "translate(36.787 26.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117470",
    "data-name": "\\uD328\\uC2A4 117470",
    d: "M811.921,502.322V408.667a47.226,47.226,0,1,0-94.452,0v93.655Z",
    transform: "translate(-714.018 -357.99)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117471",
    "data-name": "\\uD328\\uC2A4 117471",
    d: "M813.373,507.225H718.92a3.45,3.45,0,0,1-3.451-3.452V410.118a50.677,50.677,0,1,1,101.355,0v93.655A3.45,3.45,0,0,1,813.373,507.225Zm-91-6.9h87.549v-90.2a43.775,43.775,0,1,0-87.549,0Z",
    transform: "translate(-715.469 -359.441)",
    fill: "#d7e0ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165644",
    "data-name": "\\uADF8\\uB8F9 165644",
    transform: "translate(178.184 184.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117472",
    "data-name": "\\uD328\\uC2A4 117472",
    d: "M799.4,453.209h0Z",
    transform: "translate(-795.953 -449.758)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117473",
    "data-name": "\\uD328\\uC2A4 117473",
    d: "M829.842,458.112H800.856a3.451,3.451,0,0,1,0-6.9h28.987a3.451,3.451,0,1,1,0,6.9Z",
    transform: "translate(-797.404 -451.209)",
    fill: "#d7e0ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165645",
    "data-name": "\\uADF8\\uB8F9 165645",
    transform: "translate(188.788 201.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117474",
    "data-name": "\\uD328\\uC2A4 117474",
    d: "M805.549,463.042h0Z",
    transform: "translate(-802.098 -459.591)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117475",
    "data-name": "\\uD328\\uC2A4 117475",
    d: "M825.383,467.945H807a3.451,3.451,0,1,1,0-6.9h18.382a3.451,3.451,0,0,1,0,6.9Z",
    transform: "translate(-803.549 -461.042)",
    fill: "#d7e0ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165651",
    "data-name": "\\uADF8\\uB8F9 165651",
    transform: "translate(0 53.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165648",
    "data-name": "\\uADF8\\uB8F9 165648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165646",
    "data-name": "\\uADF8\\uB8F9 165646",
    transform: "translate(0 0.107)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_149820",
    "data-name": "\\uC0AC\\uAC01\\uD615 149820",
    width: 161.442,
    height: 92.973,
    transform: "translate(3.452 3.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117476",
    "data-name": "\\uD328\\uC2A4 117476",
    d: "M862.5,474.935H694.152V375.059H862.5Zm-161.443-6.9h154.54v-86.07H701.055Z",
    transform: "translate(-694.152 -375.059)",
    fill: "#d7e0ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165647",
    "data-name": "\\uADF8\\uB8F9 165647",
    transform: "translate(1.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117477",
    "data-name": "\\uD328\\uC2A4 117477",
    d: "M857.487,377H696.139l20.168,17.211,14.149,12.07c1.651,1.406,3.84,3.265,6.018,5.132l18.834,16.065,15.483,13.207a9.626,9.626,0,0,0,12.04,0l15.485-13.207,18.831-16.065c2.186-1.867,4.364-3.726,6.026-5.132l14.146-12.07Z",
    transform: "translate(-693.897 -373.546)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117478",
    "data-name": "\\uD328\\uC2A4 117478",
    d: "M777.752,447.7a12.688,12.688,0,0,1-8.256-2.941l-34.319-29.273c-1.679-1.438-3.36-2.868-4.8-4.092L694.84,381.075,697.082,375H858.43l2.24,6.078-34.313,29.278c-1.439,1.218-3.249,2.763-5.12,4.359l-35.222,30.047A12.72,12.72,0,0,1,777.752,447.7Zm-71.308-65.8,28.412,24.239c1.441,1.225,3.127,2.661,4.806,4.1l34.312,29.268a6.431,6.431,0,0,0,7.564,0l35.219-30.043c1.878-1.6,3.695-3.151,5.129-4.366l27.182-23.2Z",
    transform: "translate(-694.84 -374.997)",
    fill: "#d7e0ec"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165649",
    "data-name": "\\uADF8\\uB8F9 165649",
    transform: "translate(1.8 46.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117479",
    "data-name": "\\uD328\\uC2A4 117479",
    d: "M696.5,450.072l53.737-46.4Z",
    transform: "translate(-694.247 -401.058)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_149821",
    "data-name": "\\uC0AC\\uAC01\\uD615 149821",
    width: 70.997,
    height: 6.903,
    transform: "translate(0 46.402) rotate(-40.811)",
    fill: "#d7e0ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165650",
    "data-name": "\\uADF8\\uB8F9 165650",
    transform: "translate(108.767 46.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117480",
    "data-name": "\\uD328\\uC2A4 117480",
    d: "M812.23,450.072l-53.744-46.4Z",
    transform: "translate(-756.231 -401.058)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_149822",
    "data-name": "\\uC0AC\\uAC01\\uD615 149822",
    width: 6.903,
    height: 71.002,
    transform: "translate(0 5.225) rotate(-49.193)",
    fill: "#d7e0ec"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_165652",
    "data-name": "\\uADF8\\uB8F9 165652",
    transform: "translate(86.745 26.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117481",
    "data-name": "\\uD328\\uC2A4 117481",
    d: "M895.72,361.461c-.283,0-.561.038-.851.045v-.093H746.418v.186a47.185,47.185,0,0,1,44.494,47.088v93.655H942.945V408.687A47.224,47.224,0,0,0,895.72,361.461Z",
    transform: "translate(-742.967 -357.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_117482",
    "data-name": "\\uD328\\uC2A4 117482",
    d: "M944.4,507.245H792.364a3.452,3.452,0,0,1-3.451-3.451V410.139a43.757,43.757,0,0,0-41.24-43.642,3.452,3.452,0,0,1-3.255-3.446v-.186a3.451,3.451,0,0,1,3.451-3.451H896.321a3.509,3.509,0,0,1,.607.053c.081,0,.162-.005.243-.005a50.735,50.735,0,0,1,50.676,50.677v93.655A3.451,3.451,0,0,1,944.4,507.245Zm-148.581-6.9H940.944v-90.2a43.823,43.823,0,0,0-43.773-43.775l-.212.014c-.185.014-.367.026-.557.031a3.556,3.556,0,0,1-.875-.093H770.513a50.644,50.644,0,0,1,25.3,43.823Z",
    transform: "translate(-744.418 -359.413)",
    fill: "#d7e0ec"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171913",
    "data-name": "\\uADF8\\uB8F9 171913",
    transform: "translate(1687.5 5295.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail_icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-2",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-3",
    "data-name": "mail_icon",
    transform: "translate(25.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-4",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-5",
    "data-name": "mail_icon",
    transform: "translate(51.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-6",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-7",
    "data-name": "mail_icon",
    transform: "translate(77.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-8",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-9",
    "data-name": "mail_icon",
    transform: "translate(103.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-10",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-11",
    "data-name": "mail_icon",
    transform: "translate(129.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-12",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-13",
    "data-name": "mail_icon",
    transform: "translate(155.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-14",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-15",
    "data-name": "mail_icon",
    transform: "translate(181.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-16",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-17",
    "data-name": "mail_icon",
    transform: "translate(0 24.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-18",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-19",
    "data-name": "mail_icon",
    transform: "translate(25.991 24.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-20",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-21",
    "data-name": "mail_icon",
    transform: "translate(51.979 24.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-22",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-23",
    "data-name": "mail_icon",
    transform: "translate(77.968 24.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-24",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-25",
    "data-name": "mail_icon",
    transform: "translate(103.957 24.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-26",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-27",
    "data-name": "mail_icon",
    transform: "translate(129.948 24.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-28",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-29",
    "data-name": "mail_icon",
    transform: "translate(155.937 24.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-30",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-31",
    "data-name": "mail_icon",
    transform: "translate(181.926 24.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-32",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-33",
    "data-name": "mail_icon",
    transform: "translate(0 49.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-34",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-35",
    "data-name": "mail_icon",
    transform: "translate(25.991 49.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-36",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-37",
    "data-name": "mail_icon",
    transform: "translate(51.979 49.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-38",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-39",
    "data-name": "mail_icon",
    transform: "translate(77.968 49.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-40",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-41",
    "data-name": "mail_icon",
    transform: "translate(103.957 49.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-42",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-43",
    "data-name": "mail_icon",
    transform: "translate(129.948 49.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-44",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-45",
    "data-name": "mail_icon",
    transform: "translate(155.937 49.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-46",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail_icon-47",
    "data-name": "mail_icon",
    transform: "translate(181.926 49.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_icon-48",
    "data-name": "mail_icon",
    d: "M.009,18.283s18.3-8.047,18.27-9.141S.009,0,.009,0L0,7.11S13.039,8.419,13.056,9.141,0,11.173,0,11.173Z",
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 0, 11.75)",
    fill: "none",
    stroke: "#c6d3e4",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobApplicationIcon2);
export default __webpack_public_path__ + "static/media/job_application_icon2.643b3795411df152831ab3399499eece.svg";
export { ForwardRef as ReactComponent };